module.exports = __webpack_public_path__ + "docusign-integ-logo.png?39bf0e5658f64acc601827e2b0492cc6";